
import type { NavbarProps } from "@/types/layout";
import { SearchBar } from "./SearchBar";
import { DownloadAppButton } from "./DownloadAppButton";
import { CartButton } from "./CartButton";
import { UserProfileDropdown } from "./UserProfileDropdown";
import MenuToggleIcon from "../sidebar/MenuToggleIcon";
import { MobileNavbar } from "./MobileNavbar";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts";

export function Navbar({
  cartItemCount,
  onCartClick,
  onDownloadAppClick,
  onToggleSidebar,
  onLogoClick,
}: NavbarProps) {

  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
   const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    setSearchQuery(query);
    
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const handleFocus = () => {
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };
  return (
    <>
      {/* Mobile Navbar  */}
      <MobileNavbar
        cartItemCount={cartItemCount}
        onSearchChange={handleSearchChange}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onCartClick={onCartClick}
        onDownloadAppClick={onDownloadAppClick}
        onToggleSidebar={onToggleSidebar}
        onLogoClick={onLogoClick}
        handleKeyDown={handleKeyDown}
        handleFocus={handleFocus}
        
      />

      {/* Desktop Navbar */}
      <nav className="hidden md:block w-full bg-navbar-bg border-b border-navbar-border shrink-0">
        <div className="navbar-container flex items-center gap-2 md:gap-3 lg:gap-4 p-2 w-full">
          <div className="flex items-center gap-2 md:gap-3 lg:gap-4 ml-1 md:ml-2">
            <button
              onClick={onToggleSidebar}
              className="p-2 hover:bg-gray-100 rounded transition-colors flex-shrink-0"
              aria-label="Toggle sidebar"
            >
              <MenuToggleIcon
                width={24}
                height={24}
                className="text-gray-700"
              />
            </button>
            <div
              onClick={onLogoClick}
              className="cursor-pointer hover:opacity-80 transition-opacity"
              role="button"
              aria-label="Go to home"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onLogoClick?.();
                }
              }}
            >
              <img
                src="/images/navbar/auqli-logo.svg"
                alt="Auqli Logo"
                className="w-[90px] md:w-[100px] lg:w-[110px] h-auto flex-shrink-0"
              />
            </div>
          </div>
          <div className="flex-1 min-w-0 max-w-[280px] md:max-w-[320px] lg:max-w-md mx-2 md:mx-3 lg:mr-[5rem]">
            <SearchBar 
              onSearchChange={handleSearchChange} 
              searchQuery={searchQuery}
              handleKeyDown={handleKeyDown}
              handleFocus={handleFocus}
            />
          </div>

          <div className="flex items-center gap-3 md:gap-4 lg:gap-[25px] flex-shrink-0">
            <div className="hidden lg:block">
              <DownloadAppButton onClick={onDownloadAppClick} />
            </div>
            <CartButton itemCount={cartItemCount} onClick={onCartClick} />
            {/* Sign Up and Login Buttons (shown only if not authenticated) */}
            {!isAuthenticated && (
              <div className="flex items-center gap-3">
                <a
                  href="/signup"
                  className="border border-zinc-500 text-zinc-500 text-sm px-4 py-1.5 rounded-md font-medium transition-colors hover:border-gray-400 hover:bg-gray-50"
                >
                  Sign up
                </a>
                <a
                  href="/login"
                  className="bg-[#16783A] text-white text-sm px-4 py-1.5 rounded-md font-medium transition-colors hover:bg-[#11642f]"
                >
                  Login
                </a>
              </div>
            )}

            <UserProfileDropdown />
          </div>
        </div>
      </nav>
    </>
  );
}
